<template>
  <div>
    <v-row>
      <v-col style="margin-left: 10rem; margin-top: 3rem;">
        <h1>Dashboards de Indicadores</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-card :loading="loading" class="mx-auto my-12" max-width="374" v-for="fatura in faturas" :key="fatura.titulo">
        <template slot="progress">
          <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
        </template>

        <v-card-title v-if="fatura.quant > 0">
          <v-btn @click="showModalIndicadores(fatura.linkBack)" :disabled="disabledButton">
            {{ fatura.titulo }}
          </v-btn>
        </v-card-title>

        <v-card-title v-else>
          <v-btn @click="showModalIndicadores(fatura.linkBack)" disabled>
            {{ fatura.titulo }}
          </v-btn>
        </v-card-title>

        <v-divider class="mx-4"></v-divider>

        <v-card-subtitle>{{ fatura.quant }} - {{ fatura.desc }}</v-card-subtitle>
        <v-card-subtitle>Total: {{ fatura.tot }}</v-card-subtitle>
      </v-card>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="dialog" maxWidth="1700">
        <template>
          <v-data-table :headers="headerFacturas" :items="dessertFacturas" :items-per-page="10"
            loading-text="Loading Facturas... Please wait" :loading="loadingDatatable"
            class="elevation-1"></v-data-table>
        </template>
      </v-dialog>

      <v-dialog v-model="dialogPending" maxWidth="1700">
        <template>
          <v-data-table :headers="headerPendings" :items="dessertPendings" :items-per-page="10"
            loading-text="Loading Pending Orders... Please wait" :loading="loadingDatatable"
            class="elevation-1"></v-data-table>
        </template>
      </v-dialog>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import utils from '@/utils';
import { getCustomerId } from './../../store/userData';
import DataTableLinkText from '@/arch/components/data-table/columns/DataTableLinkText'
import DataTableTransformValueColumn from '@/arch/components/data-table/columns/DataTableTransformValueColumn'
import DataTableTransformLinkColumn from '@/arch/components/data-table/columns/DataTableTransformLinkColumn'
import DataTableCurrencyColumn from '@/arch/components/data-table/columns/DataTableCurrencyColumn'

export default {
  name: 'ViewIndicadores',
  data() {
    return {
      loading: true,
      user: '',
      filters: {
        FISCAL_CODE: null
      },
      isTigre: false,
      faturas: {
        FaturaDia:
        {
          titulo: "Facturas emitidas en el día",
          linkBack: "FaturaDia",
          desc: "Facturas",
          quant: 0,
          tot: 0
        },
        FaturaUltimo15:
        {
          titulo: "Facturas emitidas últimos 15 dias",
          linkBack: "FaturaUltimo15",
          desc: "Facturas",
          quant: 0,
          tot: 0
        },
        FaturaVencer:
        {
          titulo: "Facturas a Vencer",
          linkBack: "FaturaVencer",
          desc: "Facturas",
          quant: 0,
          tot: 0
        },
        FaturaVencida:
        {
          titulo: "Facturas vencidas",
          linkBack: "FaturaVencida",
          desc: "Facturas",
          quant: 0,
          tot: 0
        },
        VendasPendentes:
        {
          titulo: "Órdenes de venda abiertas",
          linkBack: "VendasPendentes",
          desc: "Pedidos",
          quant: 0,
          tot: 0
        },
      },
      currentIndex: 0,
      dialog: false,
      dialogPending: false,
      dialogLoading: false,
      headerFacturas: [
        {
          text: this.$i18n.t('billingNumber'),
          align: 'start',
          sortable: true,
          value: 'INVOICE',
          component: DataTableLinkText,
          options: {
            to: { name: 'BillingDetails' },
            field: 'INVOICE',
            transform(value) {
              return value.replace('VE', '').trim()
            }
          }
        },
        {
          text: this.$i18n.t('order'),
          align: 'start',
          sortable: true,
          value: 'SALES_ORDER',
        },
        {
          text: this.$i18n.t('purchaseOrder'),
          align: 'start',
          sortable: true,
          value: 'CUSTOMER_PO',
        },
        {
          text: this.$i18n.t('billingDate'),
          align: 'start',
          sortable: true,
          value: 'DATE_BILLING',
        },
        {
          text: this.$i18n.t('vencimientoDate'),
          align: 'start',
          sortable: true,
          value: 'DUE_DATE',
        },
        {
          text: this.$i18n.t('status'),
          align: 'start',
          sortable: true,
          value: 'STATUS_PAYMENT',
          component: DataTableTransformValueColumn,
          options: {
            transform: item => this.$i18n.t(item)
          }
        },
        {
          text: this.$i18n.t('totalValue'),
          align: 'start',
          sortable: true,
          value: 'PRICE',
          component: DataTableCurrencyColumn,
          options: {
            prefix: '$',
            dynamicPrefix: 'CURRENCY',
            decimals: config.VUE_APP_DECIMALS
          }
        },
        this.validateCountryColumn(),
        this.validateCountryColumnFatura(),
      ],
      dessertFacturas: [],
      dessertPendings: [],
      disabledButton: false,
      loadingDatatable: false,
      headerPendings: [
        {
          text: this.$i18n.t('orderNumber'),
          align: 'start',
          sortable: true,
          value: 'SALES_ORDER',
        },
        {
          text: this.$i18n.t('purchaseOrder'),
          align: 'start',
          sortable: true,
          value: 'CUSTOMER_PO',
        },
        {
          text: this.$i18n.t('createdDate'),
          align: 'start',
          sortable: true,
          value: 'ORDER_DATE',
          component: 'DataTableDateOnlyColumn'
        },
        {
          text: this.$i18n.t('requestDate'),
          align: 'start',
          sortable: true,
          value: 'LINE_REQUEST_DATE',
          component: 'DataTableDateOnlyColumn'
        },
        {
          text: this.$i18n.t('productCode'),
          align: 'start',
          sortable: true,
          value: 'ITEM',
        },
        {
          text: this.$i18n.t('product'),
          align: 'start',
          sortable: true,
          value: 'DESCRIPTION',
        },
        {
          text: this.$i18n.t('requestedAmount'),
          align: 'start',
          sortable: true,
          value: 'ORDERED_QUANTITY',
        },
        {
          text: this.$i18n.t('pendingAmount'),
          align: 'start',
          sortable: true,
          value: 'PENDING_QTY',
        },
        {
          text: this.$i18n.t('pendingValue'),
          align: 'start',
          sortable: true,
          value: 'PRICE',
          component: 'DataTableCurrencyColumn',
          infoMessage: this.$i18n.t('valueWithoutTaxes'),
          options: {
            prefix: '$',
            dynamicPrefix: 'CURRENCY', //TODO: diferente do Order_all, não existe o campo no objeto
            decimals: config.VUE_APP_DECIMALS
          }
        },
        {
          text: this.$i18n.t('status'),
          align: 'start',
          sortable: true,
          value: 'RELEASED_STATUS',
        },
      ],
    }
  },
  async mounted() {
    await this.getDashInfo();
  },
  methods: {
    async getDashInfo() {

      this.loading = true
      this.disabledButton = true

      let country = config.VUE_APP_COUNTRY
      await axios.get(`${config.VUE_APP_API_URL}venusa/faturamento_dash`, { params: { USERID: utils.loadUserId(), unidadePais: country, customer: getCustomerId(), TOKEN: utils.loadToken() } })
        .then(({ data }) => {
          const { lista } = data

          this.faturas.FaturaDia.quant = lista.FaturaDia.quant;
          this.faturas.FaturaDia.tot = lista.FaturaDia.tot;

          this.faturas.FaturaUltimo15.quant = lista.FaturaUltimo15.quant;
          this.faturas.FaturaUltimo15.tot = lista.FaturaUltimo15.tot;

          this.faturas.FaturaVencer.quant = lista.FaturaVencer.quant;
          this.faturas.FaturaVencer.tot = lista.FaturaVencer.tot;

          this.faturas.FaturaVencida.quant = lista.FaturaVencida.quant;
          this.faturas.FaturaVencida.tot = lista.FaturaVencida.tot;

          this.faturas.VendasPendentes.quant = lista.VendasPendentes.quant;
          this.faturas.VendasPendentes.tot = lista.VendasPendentes.tot;

          this.isTigre = lista.isTigre;

          this.loading = false
          this.disabledButton = false
        }).catch((error) => {
          console.log(error)
          this.items = this.defaultBanners
        })
    },
    async showModalIndicadores(linkBack) {

      if (linkBack != 'VendasPendentes') {
        this.dialog = true;
      } else {
        this.dialogPending = true;
      }

      this.dialogLoading = true;
      this.loadingDatatable = true;

      this.dessertFacturas = [];
      this.dessertPendings = [];

      let arrFactura = [];
      let arrPending = [];

      let country = config.VUE_APP_COUNTRY
      await axios.get(`${config.VUE_APP_API_URL}venusa/get_filter_dash`, {
        params: {
          USERID: utils.loadUserId(), unidadePais: country, customer: getCustomerId(), LINKBACK: linkBack, TOKEN: utils.loadToken()
        }
      }).then(({ data }) => {
        const { lista } = data

        Object.keys(lista).sort().forEach(function (key) {
          if (linkBack != 'VendasPendentes') {
            arrFactura.push({
                INVOICE: lista[key].INVOICE,
                SALES_ORDER: lista[key].SALES_ORDER,
                CUSTOMER_PO: lista[key].CUSTOMER_PO,
                DATE_BILLING: lista[key].DATE_BILLING,
                DUE_DATE: lista[key].DUE_DATE,
                STATUS_PAYMENT: lista[key].STATUS_PAYMENT,
                PRICE: lista[key].PRICE,
                SHIP_LOCATION: lista[key].SHIP_LOCATION,
              });
            // this.dessertFacturas.push(
            //   {
            //     INVOICE: lista[key].INVOICE,
            //     SALES_ORDER: lista[key].SALES_ORDER,
            //     CUSTOMER_PO: lista[key].CUSTOMER_PO,
            //     DATE_BILLING: lista[key].DATE_BILLING,
            //     DUE_DATE: lista[key].DUE_DATE,
            //     STATUS_PAYMENT: lista[key].STATUS_PAYMENT,
            //     PRICE: lista[key].PRICE,
            //     SHIP_LOCATION: lista[key].SHIP_LOCATION,
            //   }
            // )
          } else {
            arrPending.push({SALES_ORDER: lista[key].SALES_ORDER,
                CUSTOMER_PO: lista[key].CUSTOMER_PO,
                ORDER_DATE: lista[key].ORDER_DATE,
                LINE_REQUEST_DATE: lista[key].LINE_REQUEST_DATE,
                ITEM: lista[key].ITEM,
                DESCRIPTION: lista[key].DESCRIPTION,
                ORDERED_QUANTITY: lista[key].ORDERED_QUANTITY,
                PENDING_QTY: lista[key].PENDING_QTY,
                PRICE: lista[key].PRICE,
                RELEASED_STATUS: lista[key].RELEASED_STATUS,});
            // this.dessertPendings.push(
            //   {
            //     SALES_ORDER: lista[key].SALES_ORDER,
            //     CUSTOMER_PO: lista[key].CUSTOMER_PO,
            //     ORDER_DATE: lista[key].ORDER_DATE,
            //     LINE_REQUEST_DATE: lista[key].LINE_REQUEST_DATE,
            //     ITEM: lista[key].ITEM,
            //     DESCRIPTION: lista[key].DESCRIPTION,
            //     ORDERED_QUANTITY: lista[key].ORDERED_QUANTITY,
            //     PENDING_QTY: lista[key].PENDING_QTY,
            //     PRICE: lista[key].PRICE,
            //     RELEASED_STATUS: lista[key].RELEASED_STATUS,
            //   }
            // )
          }
        });

        this.dessertFacturas = arrFactura;
        this.dessertPendings = arrPending;




        this.dialogLoading = false;
        this.loadingDatatable = false;
      }).catch((error) => {
        console.log(error)
        this.items = this.defaultBanners
      })




    },
    validateCountryColumn() {

      if (config.VUE_APP_COUNTRY == 'EC') {
        return {
          text: this.$i18n.t('shippingLocation'),
          align: 'start',
          sortable: false,
          value: 'SHIPPING_INSTRUCTIONS',
        }
      }
      return {
        text: this.$i18n.t('shippingLocation'),
        align: 'start',
        sortable: false,
        value: 'SHIP_LOCATION',
      }
    },
    validateCountryColumnFatura() {
      if (config.VUE_APP_COUNTRY == 'UY') {
        return {
          text: this.$i18n.t('acoes'),
          align: 'start',
          sortable: false,
          value: 'LINK_FATURA',
          component: DataTableTransformLinkColumn
        }
      }
      return {};
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    countryConfig() {
      return utils.getCountryConfig()
    },
  }
}
</script>

<style scoped lang="sass">
.textPosition
  top: 10vh
  left: 10vh
  position: absolute

  &.mobile
    top: 0
    left: 0
    position: relative
    width: 85vw
    height: 100%

    .content
      .text-h4
        font-size: 1.5rem !important
      .text-h6
        font-size: 1rem !important
.fade-transition-enter-active,
.fade-transition-leave-active
  transition-duration: 0.5s
  transition-property: opacity
  transition-timing-function: ease

.fade-transition-enter,
.fade-transition-leave-active
  opacity: 0
</style>